import React from 'react';
import Header from '../../../components/header/header.component';
import Footer from '../../../components/footer/footer.component';
import FinishedListComponent from '../../../components/finished/list/finished-list.component';
import './finished-list.styles.scss';


const FinishedList = (props) => {
  return (
    <div className='parent'>
      <Header /> 
      <div className='task-list'>
        <div className='task-list-title'>
          <h3>Servicios finalizados</h3>
        </div>

        <FinishedListComponent {...props} />

      </div>

      <Footer />
    </div>
  )
};

export default FinishedList;
